interface QueueablePromise {
  key: string,
  method: () => Promise<any>,
}

export default class PromiseQueue {
  private currentPromise: QueueablePromise | null = null
  private queue: QueueablePromise[] = []

  public get currentKey (): string | null {
    return this.currentPromise && this.currentPromise.key
  }

  public get lastQueuedKey (): string | null {
    if (this.queue.length < 1) return null
    return this.queue[this.queue.length - 1].key
  }

  public enqueue (key: string, method: () => Promise<any>): Promise<any> {
    return new Promise((resolve, reject): void => {
      const wrappedMethod = async (): Promise<any> => {
        try {
          const result = await method()
          resolve(result)
        } catch (e) {
          reject(e)
        }
      }

      const promise: QueueablePromise = { key, method: wrappedMethod }
      this.queue.push(promise)
      if (!this.currentPromise) this.next()
    })
  }

  public unqueue (): QueueablePromise | null {
    return this.queue.pop() || null
  }

  protected clear (): QueueablePromise[] {
    const queuedItems = this.queue
    this.queue = []
    return queuedItems
  }

  // Does nothing if the queue is empty
  private async next (): Promise<any> {
    this.currentPromise = this.queue.shift() || null
    if (!this.currentPromise) return
    try {
      await this.currentPromise.method()
    } catch (e) {
      // We are using a queue in the first place because the items depend on one another.
      // Executing the subsequent items might give unexpected results, so skip them.
      this.clear()
    } finally {
      this.next()
    }
  }
}
